// extracted by mini-css-extract-plugin
export default {"productCarousel":"k1-z"};